function TrainingItemMonth({ title, tooltip = '', isRangeStart = false, isRangeEnd = false, isSingleDay = false }) {
	const isVisibleRangeStart = isRangeStart && !isRangeEnd
	const isVisibleRangeEnd = isRangeEnd && !isRangeStart
	const isFullyVisibleRange = isSingleDay || (isRangeStart && isRangeEnd)
	const roundedClass = isFullyVisibleRange
		? 'rounded'
		: isVisibleRangeStart
		? 'rounded-l rounded-r-none'
		: isVisibleRangeEnd
		? 'rounded-r rounded-l-none'
		: 'rounded-none'

	return (
		<div
			title={tooltip || title}
			className={`relative z-10 flex h-6 w-full min-w-0 items-center overflow-hidden whitespace-nowrap bg-emerald-100 px-2 text-left text-xs font-semibold text-emerald-800 ${roundedClass}`}>
			<span className="block min-w-0 truncate">{title}</span>
		</div>
	)
}

export default TrainingItemMonth
